import { Serializable } from '../../../core/models/serializable';
import { BannerViewModel } from './banne-view-model';

export class BannerListViewModel implements Serializable<BannerListViewModel> {
  fromObject(obj: any): BannerListViewModel {
    Object.assign(this, obj);

    this.desktopBannerList = [];
    this.resposiveBannerList = [];

    if (
      obj.desktopBannerList &&
      obj.desktopBannerList.length &&
      obj.desktopBannerList.length > 0
    ) {
      obj.desktopBannerList.forEach((c) => {
        let t = new BannerViewModel();
        t = t.fromObject(c);
        this.desktopBannerList.push(t);
      });
    }

    if (
      obj.resposiveBannerList &&
      obj.resposiveBannerList.length &&
      obj.resposiveBannerList.length > 0
    ) {
      obj.resposiveBannerList.forEach((c) => {
        let t = new BannerViewModel();
        t = t.fromObject(c);
        this.resposiveBannerList.push(t);
      });
    }

    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }
  public desktopBannerList: BannerViewModel[];
  public resposiveBannerList: BannerViewModel[];

  public bannerPositionName: string;

  public desktopBannerSizes: string;
  public responsiveBannerSizes: string;
}
